import { useState } from 'react';
import { onboardDoctor } from '../utils/apiCalls';
import Modal from './Modal';

export default function OnboardDoctor({ isOpen, onClose, clinicId, locationId, token, onSuccess, userRole }) {
    const initialFormData = { full_name: '', email: '', phone: '', role: 'user' }
    const [formData, setFormData] = useState(initialFormData);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');


    //  handle change for form fields
    const handleChange = (event) => {
        let { name, value } = event.target;
        if (name === 'phone') {
            const digits = value.replace(/\D/g, '');
            const limitedDigits = digits.slice(0, 10);

            if (limitedDigits.length <=3) {
                value = limitedDigits;
            } else if (limitedDigits.length <=6) {
                value =`${limitedDigits.slice(0,3)}-${limitedDigits.slice(3)}`;
            } else {
                value = `${limitedDigits.slice(0,3)}-${limitedDigits.slice(3,6)}-${limitedDigits.slice(6)}`;
            }
        }

        setFormData({ ...formData, [name]:value });
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    const normalizePhone = (phone) => phone ? `1+${phone.replace(/\D/g, '')}` : undefined;

    // Validate phone/email 
    const validateField = (name, value) => {
        setError('');

        if (!value) {
            switch (name) {
                case 'full_name':
                    setError('Please fill out Name');
                    break;
                case 'email':
                    setError('Please enter a valid email address');
                    break;
                case 'phone':
                    setError('Please enter a 10-digit phone number');
                    break;
                default:
                    setError('');
                    break;
            }
        } else {
            switch (name) {
                case 'email':
                    if (!emailRegex.test(value)) {
                        setError('Please enter a valid email address');
                    }
                    break;
                case 'phone':
                    if (!phoneRegex.test(value)) {
                        setError('Please enter a 10-digit phone number');
                    }
                    break;
                default:
                    setError('');
                    break; 
            }
        }
    };

    const handleBlur = (event) => {
        const { name, value } = event.target;
        validateField(name, value);
    }

    const handleValidate = () => {
        // let valid = true;
        setError('');

        if (!formData.full_name) {
            setError('Name is required');
            return false;
        }
        else if (!formData.email ||!emailRegex.test(formData.email)) {
            setError('Valid email address is required');
            return false;
        }
        else if (!formData.phone || !phoneRegex.test(formData.phone)) {
            setError('Please enter 10-digit phone number');
            return false;
        }
        return true;
        
    }

    const handleSubmit = async (event) => {
    event.preventDefault();
    if (!handleValidate()) return;

        setLoading(true);
        setError('');

        // Note: payload for onboarding docs and users the same - exception is this route always sets is_doctor to true 
        const payload = { doctor_name: formData.full_name, location_id: locationId, clinic_id: clinicId, phone: normalizePhone(formData.phone), full_name: formData.full_name, email: formData.email, role: formData.role, is_doctor: true};
        console.log('Onboard payload:', payload);

        try {
            const result = await onboardDoctor(payload, token );
            console.log('ONBOARD RESULT', result);
            if (!result?.user?.user_id) {
                throw new Error('User record was not created');
            }
            setFormData(initialFormData);
            onClose();
            if (onSuccess) onSuccess();
            } catch (error) {
                setError(error.message || 'Failed to onboard doctor');
            } finally {
                setLoading(false);
            }
        }

    if (!isOpen) return null;

    return (
        <Modal >
            <h2 className="text-xl font-bold text-docpgrPurple mb-4">
                Onboard Doctor
            </h2>

            {error && <p className="text-red-500 mb-2">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
                {/* name  */}
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Doctor Name
                    </label>
                    <input type='text' name='full_name' value={formData.full_name} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>
                {/* email  */}
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Email
                    </label>
                    <input type='email' name='email' value={formData.email} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>
                {/* Phone  */}
                    <div>
                        <label className='block text-sm font-medium mb-1'>
                            Phone
                        </label>
                        <input type='tel' name='phone' value={formData.phone} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' placeholder="999-555-1234"/>
                    </div>
                {(userRole === 'super_admin' || userRole==='admin') && (
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Role
                    </label>
                    <select value={formData.role} name='role' onChange={handleChange} onBlur={handleBlur} className='w-full border rounded p-2'>
                        <option value='user'>User</option>
                        <option value='admin'>Admin</option>
                    </select>
                </div>
                )}

                <div className='flex justify-end gap-2'>
                    <button type='button' onClick={onClose} className='px-4 py-2 rounded border text-gray-700 hover:bg-gray-100'>
                        Cancel
                    </button>
                    <button type='submit' disabled={loading} className='px-4 py-2 rounded border bg-docpgrPurple text-white hover:bg-docpgrPurple90'>
                        { loading ? 'Onboarding...' : 'Onboard' }
                    </button>
                </div>
            </form>
        </Modal>
    )
}